import React from 'react';
import * as Styled from './StyledFormRow';

export function FormRow(props) {
    return <Styled.FormRow>{props.children}</Styled.FormRow>;
}
export const Row = FormRow;
export default FormRow;
